import React, { useState } from "react";
import { TileLayer } from "react-leaflet";
import AppleMapkitLeafletLayer from "./AppleMapkitLeafletLayer";
import {
  BASE_MAP_GROUPS,
  BASE_MAP_URLS,
  BaseMapValue,
  getAppleMapType,
  isAppleBaseMap,
} from "../../config/maps/baseMaps";
import "./BaseMapLayerControl.css";

type Props = {
  value: BaseMapValue;
  onChange: (value: BaseMapValue) => void;
  tokenUrl?: string;
  top?: number;
  right?: number;
};

export default function BaseMapLayerControl({
  value,
  onChange,
  tokenUrl,
  top = 12,
  right = 12,
}: Props) {
  const [open, setOpen] = useState(false);

  const handleChange = (nextValue: BaseMapValue) => {
    onChange(nextValue);
    setOpen(false);
  };

  return (
    <>
      {isAppleBaseMap(value) && tokenUrl ? (
        <AppleMapkitLeafletLayer
          tokenUrl={tokenUrl}
          type={getAppleMapType(value)}
        />
      ) : (
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url={BASE_MAP_URLS[value]}
        />
      )}

      <button
        type="button"
        className={`base-map-layer-control__button${open ? " base-map-layer-control__button--active" : ""}`}
        aria-label="Changer le fond de carte"
        title="Changer le fond de carte"
        onClick={() => setOpen((current) => !current)}
        style={{ top, right }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/asset/images/mapicon/layers.png`}
          alt=""
          className="base-map-layer-control__icon"
        />
      </button>

      {open && (
        <div
          className="base-map-layer-control__panel"
          style={{ top: top + 42, right }}
        >
          <div className="base-map-layer-control__title">Fond de carte</div>

          {BASE_MAP_GROUPS.map((group) => (
            <div className="base-map-layer-control__group" key={group.label}>
              <div className="base-map-layer-control__group-title">
                {group.label}
              </div>

              {group.options.map((option) => (
                <label
                  key={option.value}
                  className={`base-map-layer-control__option${value === option.value ? " base-map-layer-control__option--active" : ""}`}
                >
                  <input
                    type="radio"
                    name="base-map"
                    value={option.value}
                    checked={value === option.value}
                    onChange={() => handleChange(option.value)}
                  />
                  <span className="base-map-layer-control__radio" />
                  <span>{option.label}</span>
                </label>
              ))}
            </div>
          ))}
        </div>
      )}
    </>
  );
}
